// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vs__dropdown-option.vs__dropdown-option--selected.vs__dropdown-option--highlight {\n  opacity: 0.95;\n}\n", ""]);
// Exports
module.exports = exports;
